import { enemies } from './battleData';
import { MEDICINE_CARDS } from './medicineCardData';

const ALL_ENEMY_IDS = enemies.map(e => e.id);

export const ACHIEVEMENTS = [
  {
    id: 'first-battle',
    name: 'First Blood',
    description: 'Win your first battle',
    emoji: '⚔️',
    tier: 'bronze',
    check: (ud) => (ud.defeatedEnemies || []).length >= 1,
  },
  {
    id: 'junior-doctor',
    name: 'Junior Doctor',
    description: 'Reach Junior Doctor level (500 XP)',
    emoji: '🩺',
    tier: 'bronze',
    check: (ud) => (ud.xp || 0) >= 500,
  },
  {
    id: 'collector-5',
    name: 'Card Collector',
    description: 'Collect 5 medicine cards',
    emoji: '💊',
    tier: 'bronze',
    check: (ud) => (ud.medicineCards || []).length >= 5,
  },
  {
    id: 'collector-10',
    name: 'Medicine Cabinet',
    description: 'Collect 10 medicine cards',
    emoji: '🗃️',
    tier: 'silver',
    check: (ud) => (ud.medicineCards || []).length >= 10,
  },
  {
    id: 'resident',
    name: 'Resident Doctor',
    description: 'Reach Resident level (2,000 XP)',
    emoji: '🏥',
    tier: 'silver',
    check: (ud) => (ud.xp || 0) >= 2000,
  },
  {
    id: 'legendary-card',
    name: 'Legend in the Making',
    description: 'Collect a legendary medicine card',
    emoji: '✨',
    tier: 'silver',
    check: (ud) => {
      const owned = new Set(ud.medicineCards || []);
      return MEDICINE_CARDS.some(c => c.rarity === 'legendary' && owned.has(c.id));
    },
  },
  {
    id: 'specialist',
    name: 'Specialist',
    description: 'Reach Specialist level (5,000 XP)',
    emoji: '⭐',
    tier: 'gold',
    check: (ud) => (ud.xp || 0) >= 5000,
  },
  {
    id: 'pathogen-hunter',
    name: 'Pathogen Hunter',
    description: 'Defeat every pathogen at least once',
    emoji: '🔬',
    tier: 'gold',
    check: (ud) => ALL_ENEMY_IDS.every(id => (ud.defeatedEnemies || []).includes(id)),
  },
];

export const TIER_STYLE = {
  bronze: { label: 'Bronze', color: '#b45309', border: '#d97706', bg: '#fffbeb', glow: 'rgba(217,119,6,0.25)' },
  silver: { label: 'Silver', color: '#475569', border: '#94a3b8', bg: '#f8fafc', glow: 'rgba(148,163,184,0.3)' },
  gold:   { label: 'Gold',   color: '#b45309', border: '#f59e0b', bg: '#fefce8', glow: 'rgba(245,158,11,0.4)' },
};

// Returns array of newly-earned Achievement objects (not yet in ud.achievements)
export const checkAchievements = (userData) => {
  const earned = new Set(userData.achievements || []);
  return ACHIEVEMENTS.filter(a => !earned.has(a.id) && a.check(userData));
};
